module.exports = __webpack_public_path__ + "img/homepage-use-case.66a26a62.png";